import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL, ENTERPRISE_DEMO_URL, BRAND } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
export function HomeFinalCta() {
  return <section aria-labelledby="final-heading" className="relative overflow-hidden border-b border-hairline-soft bg-surface" data-id="element-148" data-mp="k4fipnksqi11">
      <div className="sf-dot-texture pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-149" data-mp="3nn8vhy5r32u5" />
      <Reveal className="relative mx-auto flex w-full max-w-[880px] flex-col items-center px-4 py-20 text-center sm:px-6 lg:py-28" data-id="element-150" data-mp="3sm26njxkehr5">
        <p className="text-sm font-medium text-lime" data-id="element-151" data-mp="1ezdwo22w3et">{BRAND.tagline}</p>
        <h2 id="final-heading" className="sf-display mt-4 text-balance text-[36px] leading-[1.04] text-text-primary sm:text-[52px]" data-id="element-152" data-mp="679321vdczg1">
          Start with your next pitch deck.
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-text-secondary" data-id="element-153" data-mp="39vkh1o8142a0">
          Explore one assessment, or discuss a workflow for your investment team.
        </p>
        <div className="mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-154" data-mp="310sol1dmek7z">
          <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
          placement: 'final',
          cta: 'try_pitch_deck_screener'
        }} size="xl" className="w-full sm:w-auto" data-id="element-155" data-mp="2w0n362xy1tyc">
            Try Pitch Deck Screener
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-156" data-mp="2ia1iq9sudbyc" />
          </CtaButton>
          <CtaButton href={ENTERPRISE_DEMO_URL} event="enterprise_demo_click" eventParams={{
          placement: 'final'
        }} variant="outline" size="xl" className="w-full sm:w-auto" data-id="element-157" data-mp="2d8ly2iukt7gh">
            Book an Enterprise Demo
          </CtaButton>
        </div>
      </Reveal>
    </section>;
}